import Vue from 'vue'
import _sortBy from 'lodash.sortby'
import _union from 'lodash.union'
import _unionBy from 'lodash.unionby'
import _mapValues from 'lodash.mapvalues'
import Auth from './packages/auth/Auth.js'
import Axios from 'axios'
import Accounting from 'accounting-js'
import moment from 'moment'

// import da from 'vee-validate/dist/locale/da'
// import de from 'vee-validate/dist/locale/de'
// import es from 'vee-validate/dist/locale/es'
// import fr from 'vee-validate/dist/locale/fr'
// import it from 'vee-validate/dist/locale/it'
// import no from 'vee-validate/dist/locale/nb_NO'
// import nl from 'vee-validate/dist/locale/nl'
// import pt from 'vee-validate/dist/locale/pt_PT'
// import sv from 'vee-validate/dist/locale/sv'
// import Echo from 'laravel-echo'
// import Pusher from 'pusher-js'
import VuePaginate from 'vue-paginate'
import VueSweetalert2 from 'vue-sweetalert2'
import VuePortal from '@linusborg/vue-simple-portal'

// import 'sweetalert2/dist/sweetalert2.min.css'

Vue.prototype.$_ = {
  sortBy: _sortBy,
  union: _union,
  unionBy: _unionBy,
  mapValues: _mapValues,
}

/**
 * Use our own custom-built authorisation package which makes use of Laravel
 * Passport to generate oauth tokens. We then store these in localStorage
 * passing them back and forth to the server, ensuring our api is secure.
 */
Vue.use(Auth)

// window.this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + Vue.auth.getToken();
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
Vue.prototype.$axios = Axios

Vue.prototype.$axios.defaults.headers.common['X-Requested-With'] =
  'XMLHttpRequest'

Vue.prototype.$axios.interceptors.request.use(
  (config) => {
    if (Vue.auth.getToken()) {
      config.headers.common = {
        ...config.headers.common,
        Authorization: 'Bearer ' + Vue.auth.getToken(),
        // 'access-token': store.get('auth')['access-token'],
        // client: store.get('auth').client,
        // uid: store.get('auth').uid,
      }
    }

    // console.log(config.headers)
    return config
  },
  (error) =>
    // Do something with request error
    Promise.reject(error),
)

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// let token = document.head.querySelector('meta[name="csrf-token"]');
//
// if (token) {
//     Axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }
/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

// window.Vue = require('vue');
Vue.config.productionTip = false // Remove Vue production message
// Vue.config.devtools = true // Show Vue devtools even in production

/**
 * BootstrapVue helps us to avoid the use of jQuery...
 */
// import BootstrapVue from 'bootstrap-vue'

// Vue.use(BootstrapVue)
/**
 * Accounting.js is a tiny JavaScript library, providing simple and advanced number, money and
 * currency formatting. Features custom output formats, parsing/unformatting of numbers, easy
 * localisation and spreadsheet-style column formatting (to line up symbols and decimals).
 */

Vue.prototype.$accounting = Accounting

/**
 * Moment.js allows us to parse, validate, manipulate and display dates and times in JavaScript.
 */
Vue.prototype.$moment = moment

/**
 * Vuejs-localization provides a convenient way to retrieve strings in various languages
 * in Vuejs.
 */

const Lang = require('vuejs-localization')
// Note that we need to specify the lang folder, in this case './lang'
Lang.requireAll(require.context('./lang', true, /\.js$/))

Vue.use(Lang)

/**
 * The idea of vue-paginate is pretty simple. You give it an array of items; specify how
 * many items per page; then get your list of items paginated!
 */
Vue.use(VuePaginate)

// Replace image on error (e.g. ItineraryShow.vue)
window.__imgErrReplace__ = function (image) {
  const parent = image.parentNode
  const tempDiv = document.createElement('div')

  tempDiv.innerHTML = image.alt

  const input = tempDiv.childNodes[0]

  parent.replaceChild(input, image)

  if (parent.className === 'airline-small') {
    parent.innerHTML = image.alt
  }
}

/**
 * Emulate Laravel's validation by using the vee-validate package for Vuejs
 */

// Vue.use(VeeValidate)
//
// Validator.localize(da)
// Validator.localize(de)
// Validator.localize(es)
// Validator.localize(fr)
// Validator.localize(it)
// Validator.localize(no)
// Validator.localize(nl)
// Validator.localize(pt)
// Validator.localize(sv)

/**
 * Sweetalert2 allows us to display pretty javascript alert messages...
 */

Vue.use(VueSweetalert2, {
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn btn-green focus:outline-none focus:shadow-outline',
  },
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// window.Pusher = Pusher
//
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'c9af45e61b851fbaf9b1',
//     cluster: 'eu',
//     encrypted: true
// })

// VuePortal - renders HTML outside of component, at the bottom of the document
Vue.use(VuePortal, {
  name: 'Portal',
})
